import * as angular from 'angular';

export class IssueExporterFactory {
    private apiRoot: string = '/api/v1/exporterconfiguration';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    get() {
        return this.$http.get(`${this.apiRoot}/`);
    }

    update(data) {
        return this.$http.put(`${this.apiRoot}/`, data);
    }
}

angular.module('app').service('IssueExporterFactory', IssueExporterFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/issue-exporter.factory.ts